import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'trigger',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		top: 16px;
		left: 50%;
		width: 220px;
		height: 140px;
		max-height: 100%;
		background-color: ${theme.color.primary.default};
		border-radius: 6px;
		padding: 30px 20px;
		transform: translate(-50%);
    box-shadow: ${theme.color.text.B3} 0 2px 5px 0;
		cursor: pointer;
		z-index: 5;
		box-sizing: border-box;
		color: white;
	`
  ],
  [
    'timerTrigger',
    `
		margin-bottom: auto;
	`
  ]
]);
